const axios = require('axios').default

const directus = axios.create({
  baseURL: process.env.REACT_APP_DIRECTUS_BACKEND || "https://the-loge.com/backend/",
  timeout: 1000
})

export default directus


// WEBPACK FOOTER //
// /src/utils/directus.js